/* -disable import/prefer-default-export */
import styled, { css } from 'styled-components';
import { Colors } from '../../../../../constants';

const CarbonCardDefault = styled.div`
  display: flex;
  padding: 8px 16px;
  align-items: flex-start;
  gap: 8px;
  align-self: stretch;
  border-top-left-radius: 8px;
  border-top-right-radius: 8px;
  cursor: pointer;
`;

export const CarbonCard = styled(CarbonCardDefault)`
  background-color: ${Colors.SUCCESS};
`;

export const CarbonCardSecondary = styled(CarbonCardDefault)`
  background-color: #394E98;
`;

export const CarbonCardText = styled.div`
  display: flex;
  align-self: center;
  color: #FFF;
  font-family: "Work Sans";
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
`;

const HeaderWrapper = styled.div`
  display: flex;
`;

const TrackingWrapper = styled.div`
  position: relative;
`;

const TrackingItemContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
  padding: 16px;
  border-radius: 8px;
  background-color: white;
  box-shadow: 0 2px 4px 0 var(--box-shadow);
  cursor: pointer;
`;

const TrackingRow = styled.div`
  display: flex;
  justify-content: space-between;

  ${({ isMobile }) => isMobile && css`
    overflow: auto;
  `}
`;

const TimelineWrapper = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;

  justify-content: space-between;

  ${({ isMobile }) => isMobile && css`
    overflow: auto;
  `}
`;

const GradientBlock = styled.div`
  position: absolute;
  background-color: white;
  width: 20%;
  height: 100%;
  top: 0;
  bottom: 0;
  z-index: 10;

  ${({ first }) =>
    first &&
    css`
      left: 0;
      background: linear-gradient(
        90deg,
        var(--tracking-item) 0%,
        var(--tracking-item-dark) 100%
      );
    `}

  ${({ last }) =>
    last &&
    css`
      right: 0;
      background: linear-gradient(
        90deg,
        var(--tracking-item-dark) 0%,
        var(--tracking-item) 100%
      );
    `}
`;

const StatusContainer = styled.div`
  display: flex;
  flex: 1;
  
  ${({ isDesktop }) =>
    isDesktop &&
    css`
      margin-left: 0;
    `}
`;

const TransportDataContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  width: 392px;
  gap: 8px;
`;

const NoTracking = styled.div`
  width: 175px;
  height: 20px;
  border-radius: 3px;

  background: linear-gradient(
    to right,
    rgba(255, 255, 255, 0),
    rgba(255, 255, 255, 0.5) 50%,
    rgba(255, 255, 255, 0) 80%
  ),  lightgray;
  background-repeat: repeat-y;
  background-size: 50px 500px;
  background-position: 0 0;
  animation: shine 1s infinite;
  
  @keyframes shine {
    to {
      background-position: 100% 0, /* move highlight to right */ 0 0;
    }
  }
`;

const TrackingContainer = styled.div`
  width: fit-content;

  ${({ isMobile }) => isMobile && css`
    display: flex;
    width: 100%;
    align-items: center;
    justify-content: center;
    padding-top: 6px;
    margin-bottom: 22px;
  `}   
`;

export const S = {
  HeaderWrapper,
  TrackingWrapper,
  TrackingItemContainer,
  TrackingRow,
  TimelineWrapper,
  GradientBlock,
  StatusContainer,
  TransportDataContainer,
  NoTracking,
  TrackingContainer
};
